import { useMutation } from "@tanstack/react-query";
import { X } from "lucide-react";
import $api from "@/zapi-frontend/shared/api/axios";
import { useMeStore } from "@/zapi-frontend/shared/hooks/useMe";
import { AppButton, FigmaTypography } from "@libs/zapi-ui/custom";

export function PinnedPromptRevisionBanner() {
  const { pinnedPromptRevisions, refetch } = useMeStore();

  const unpin = useMutation({
    mutationFn: async (featureKey: string) => {
      await $api.post(`/admin/prompts/features/${featureKey}/unpin`);
    },
    onSuccess: () => refetch?.()
  });

  if (!pinnedPromptRevisions?.length) return null;

  return (
    <>
      {pinnedPromptRevisions.map((pin) => (
        <div
          key={pin.featureKey}
          className="bg-purple-100 border-l-4 border-purple-500 px-4 py-3 flex items-center justify-between"
        >
          <FigmaTypography variant="body-2" className="text-purple-800">
            Your <span className="font-medium">{pin.featureKey}</span> generations run on prompt revision{" "}
            <span className="font-medium">{pin.revisionNumber ?? pin.revisionId}</span>, not the one everyone else gets.
          </FigmaTypography>
          <AppButton
            data-testid={`pinned-prompt-revision-${pin.featureKey}-button`}
            size="sm"
            appearance="outlined"
            onClick={() => unpin.mutate(pin.featureKey)}
            disabled={unpin.isPending}
            className="flex items-center gap-2 text-purple-700 border-purple-200 hover:bg-purple-50 bg-white"
          >
            <X className="w-4 h-4" />
            Back to the active revision
          </AppButton>
        </div>
      ))}
    </>
  );
}
